interface ContainerActionsProps {
	readonly disabled?: boolean;
	readonly children: React.ReactNode;
}

const ContainerActionsComponent = ({ disabled, children }: ContainerActionsProps) => {
	if (disabled) {
		return null;
	} else {
		return <>{children}</>;
	}
};

export { ContainerActionsComponent };
